import React from "react";
import {connect} from "react-redux";
import {Icon, utils} from "@mc/mc-legacy";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
import ItemList from "../components/ItemList";
import * as actions from "../actions/mojeUkolyActions";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import {Button, Col, Row, Tooltip} from "reactstrap";
import {getStatusIcon} from "../components/StatusBar";
import SignRequestTitle from "../components/SignRequestTitle";
import ShowButton from "../components/ShowButton";
import * as groupMenuActions from "../actions/groupMenuActions";
import * as pozadavkyActions from "../actions/pozadavkyActions";
import EnumState from "../api/gen/qsign/types/EnumState";
import Type from "../api/gen/qsign/types/Type";
import MessageEmptyList from "../components/MessageEmptyList";
import LabeledValue from "../components/LabeledValue";
import * as appUtils from "../utils/appUtils";
import moment from "moment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
import CountIcon from "../components/CountIcon";
import SignRequestWithCountsVO from "../api/gen/qsign/types/SignRequestWithCountsVO";
import PrilohyButton from "../components/PrilohyButton";
import {Text} from "@mc/ui-v3";
import {Popover,Position} from '@mc/react-core';
import Linkify from "../utils/parseUrl";

/**
 * Nevyřízené požadavky page.
 */

class UkolyNevyrizenePage extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, true);
    this.handleFilter();
  }

  handleFilter() {
    const { filterList } = this.props;
    this.props.dispatch(pozadavkyActions.filter({ ...filterList.filter, stateList: [EnumState.INIT] }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps, false);

    if (nextProps.itemList.fetched && nextProps.itemList.rows.length > 0) {
      const rows = nextProps.itemList.rows;
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has("showId")) {
        const item = rows.find((i) => i.id === parseInt(urlParams.get("showId")));

        if (item) {
          let mode = PodepisovaniPdfViewer.VIEW_MODE.BASE;

          if (urlParams.get("mode") === "mobile") {
            mode = PodepisovaniPdfViewer.VIEW_MODE.MOBILE;
          }

          urlParams.delete("showId");
          urlParams.delete("mode");
          const search = urlParams.toString().length > 0 ? "?" + urlParams.toString() : "";
          window.history.replaceState({}, document.title, window.location.origin + window.location.pathname + search);
          this.handleZobrazit(item, null, mode);
        }
      }
    }
  }

  fetchData = (props, forceFetch) => {
    const { dispatch } = props;
    dispatch(actions.fetchIfNeeded(forceFetch));

    if (forceFetch) {
      dispatch(groupMenuActions.invalidate());
    }
  };
  handleZobrazit = (signRequest, type, viewMode) => {
    this.props.dispatch(
      pdfViewerActions.showDocuments(
        signRequest,
        true,
        type,
        () => {
          this.fetchData(this.props, true);
        },
        viewMode,
        screen.width
      )
    );
  };

  formatDate = (date) => {
    if (!date) {
        return "-"
    }
    return moment(date).format("D.M.YYYY");
  };
  renderItem = (item: SignRequestWithCountsVO, icon) => {
    const { error } = item;
    const statusItems = [
      {
        status: "waiting",
        title: "Nevyřízených dokumentů: " + item.waitingDocuments,
        count: item.waitingDocuments,
        onClick: () => this.handleZobrazit(item, Type.WAITING, PodepisovaniPdfViewer.VIEW_MODE.BASE),
      },
    ];
    const statusIcon = getStatusIcon(statusItems[0].status);
    return (
      <Row noGutters>
        <Col xl={9} lg={8} md={12} sm={12} xs={12}>
          <Row className="d-none d-md-flex">
            <Col className="ml-3">
              <SignRequestTitle
                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}
                signRequest={item}
                customRender={(item) => {
                  if (item.step || item.attachmentCount>0) {
                    return (
                      <div className="d-flex">
                        {item.step && (
                          <Icon
                            title="Dokumenty jsou stále v procesu schvalování"
                            className={"info-icon mr-2"}
                            icon={"exclamation-triangle"}
                          />
                        )}

                        {item.attachmentCount>0 && <PrilohyButton attachmentCount={item.attachmentCount} itemID={item.id} />}
                      </div>
                    );
                  }

                  return null;
                }}
              />
            </Col>
          </Row>
          <Row className="d-md-none d-flex">
            <Col className="ml-3">
              <SignRequestTitle
                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.MOBILE)}
                signRequest={item}
                customRender={(item) => {
                    if (item.step || item.attachmentCount>0) {
                        return (
                            <div className="d-flex">
                                {item.step && (
                                    <Icon
                                        title="Dokumenty jsou stále v procesu schvalování"
                                        className={"info-icon mr-2"}
                                        icon={"exclamation-triangle"}
                                    />
                                )}

                                {item.attachmentCount>0 && <PrilohyButton attachmentCount={item.attachmentCount} itemID={item.id} />}
                            </div>
                        );
                    }

                    return null;
                }}
              />

            </Col>
          </Row>
          {/* <SignRequestInfoData showDeadlineExpired signRequest={item}/> */}
          <Row className={"mt-2 mb-2 pl-4 pr-4"}>
            <Col lg={3} md={4} sm={6} xs={4}>
              <LabeledValue label="Vloženo" value={this.formatDate(item.created)} />
            </Col>
            <Col lg={4} md={4} sm={6} xs={8}>
              <LabeledValue label="Předkladatel" value={appUtils.getPracovnikLabel(item.pracovnikRequest)} />
            </Col>
            <Col lg={4} md={4} sm={6} xs={8}>
              <LabeledValue label="Termín" value={this.formatDate(item.signUntil)} />
            </Col>
          </Row>
            {item.description&&<Row className={"mt-2 mb-2 pl-4 pr-4"}>

                <Col xs={10}>
                    <Popover
                        className={"custom-popover"}
                        minimal
                        content={
                            <div className={"p-2 max-popover-width"}>
                                <Linkify text={item.description}/>
                            </div>
                        }
                        position={Position.BOTTOM_LEFT}
                    >
                        <Linkify linkAtStartOnly={true} text={item.description} style={{cursor: "pointer"}}
                                 className={"truncate-text"}/>
                    </Popover>
                </Col>
            </Row>}
        </Col>
        {!error &&
          Object.entries(statusItems).map(([key, value]) => {
            const icon = getStatusIcon(value.status);
            return (
              <Col
                key={key}
                className="d-none d-md-flex pl-4 pr-4 status-item align-items-center justify-content-center"
                style={{
                  borderLeft: "solid rgba(48, 63, 161, 0.24)",
                  borderWidth: "0 0.5px 0 0.5px",
                }}
              >
                <CountIcon
                  onClick={value.onClick}
                  title={value.title}
                  icon={icon.icon}
                  color={icon.color}
                  count={value.count}
                />
              </Col>
            );
          })}
        {/*<StatusBar items={statusItems}/>*/}
        {!error && (
          <Col
            xs={6}
            sm={6}
            md={6}
            lg={2}
            className="d-md-none d-flex align-items-center justify-content-center"
            style={{
              borderTop: "1px solid #dfe2f1",
            }}
            onClick={() => this.handleZobrazit(item, Type.WAITING, PodepisovaniPdfViewer.VIEW_MODE.MOBILE)}
          >
            <FontAwesomeIcon icon={statusIcon.icon} className="icon mr-1" />
            {statusItems[0].count}
          </Col>
        )}
        <Col md={6} lg={2} className={"action-button-wrapper d-none d-md-flex"}>
          <ShowButton onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)} />
        </Col>
        <Col xs={6} sm={6} className="d-md-none mr-0">
          <Button
            block
            className={"btn-lg"}
            color={"primary"}
            onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.MOBILE)}
          >
            Zobrazit
          </Button>
        </Col>
          <Col xs={12} sm={"auto"}>
              <div
                  className="actions actions-button h-100 d-flex "
                  style={{
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#fff",
                  }}
              >
              </div>
          </Col>
      </Row>
    );
  };

  render() {
    const { itemList } = this.props;
    const listProps = {
      md: 12,
      itemList,
      loadMore: actions.loadMore,
      renderItem: this.renderItem,
      renderActions: () => {},
      emptyList: (
        <MessageEmptyList>
          <div className="message">
            Žádné dokumenty k podepsání
            <div className="thumbup">
              <Icon icon="thumbs-o-up fa-4x" />
            </div>
          </div>
        </MessageEmptyList>
      ),
    };
    return (
      <CustomPageLayout
        header
        headerButton={false}
        vlastniPodepsaniHeader={true}
        title="Nevyřízené dokumenty"
        searchPlaceholder="Vyhledat v nevyřízených dokumentech"
        mobilHeader="Nevyřízené"
        menu={<GroupMenu />}
      >
        <ItemList {...listProps} />
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    itemList: utils.storeFromArea(state, actions.MU_NEVYRIZENE_LIST),
    filterList: utils.storeFromArea(state, pozadavkyActions.POZADAVKY_SEARCH_LIST),
  };
}

export default connect(mapStateToProps)(UkolyNevyrizenePage);
